export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Hold Reason\",\n    \"label_other\": \"{{count}} Hold Reasons\"\n}\n"